import { useState, useEffect } from "react";
import React from "react";
import { checklist, machineProfile, vendor } from "../../api";
import { toast } from "react-toastify";
import { dateFormat, getEmptyField, printLocation, renderImage } from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../components/form/HorizontalNormalTextarea";
import { DatepickerOpt } from "../../components/form/DatepickerOpt";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";
import { Task } from "../../components/Task";
import { PermissionChecker } from "../../components/PermissionChecker";

function AddChecklist() {
  const { id } = useParams();
  const editMode = !!id;

  const [isLoading, setIsLoading] = useState(false);
  const [emptyField,setEmptyField] = useState([])
  const [dataToSend, setDataToSend] = useState({
    name: "",
    description: "",
    tasks:[]
  });

  const navigate = useNavigate();
  function backToList() {
    navigate(-1);
  }

  useEffect(() => {
    if (editMode) {
      getRecord()
    }

  }, []);
  

  async function getRecord() {
    setIsLoading(true)
    const result = await checklist.getOne(id );
 
    if (result.ok) {
      const body = await result.json();
      let data = body.data;
      const defaultValue = {
            name:data.name,
        description: data.description,
            tasks:data.tasks|| []
      };

      setDataToSend(defaultValue);
      setIsLoading(false);
    }

  }

  const handleOnchange = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    setIsLoading(true)
    try {
      let payload = { ...dataToSend };

      const mandatory = ['name']
      const ef = getEmptyField(payload, mandatory)
      setEmptyField(ef)
      if (ef.length > 0) {
        toast.error("Mandatory field must be filled");
        return;
      }


    
      //console.log({ payload });
      let res 
      if (!editMode) {
        res = await checklist.create(payload);
      } else {
        res = await checklist.update(id,payload)
      }
      
      if (res.ok) {
        toast.success("Successfully Saved");
        if (!editMode) {
          backToList();
        }
      } else {
        toast.error("Something went wrong, please try again");
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <LoadingIndicator open={isLoading} />
      <CardHeader>{editMode && "Edit "}Checklist Information</CardHeader>

      <CardBody>
        <div className="row">
          <div className="col-9">
            <div>
              <NormalInput
                required={true}
                value={dataToSend["name"]}
                label="Name"
                onchange={handleOnchange}
                name="name"
                emptyField={emptyField}
              />

              <NormalTextArea
                value={dataToSend["description"]}
                label="Description"
                onchange={handleOnchange}
                name="description"
              />

              <Task onChange={(v) => handleOnchange({
                target: {
                  name: 'tasks',
                  value: v
                }
              })} value={dataToSend['tasks']} />

              
            </div>
          </div>
        </div>

        <div className="mt-4 flex ">
          <PermissionChecker permissions={["create checklist", "edit checklist"]} hideIfNotAllowed>
          <button
            
            className="btn btn-outline-theme btn-lg me-2"
            onClick={handleSubmit}
          >
            {editMode ? "SAVE" : "ADD"}
            </button>
            </PermissionChecker>
          <button
            className="btn btn-outline-danger btn-lg"
            onClick={backToList}
          >
            CANCEL
          </button>
        </div>
      </CardBody>
    </Card>
  );
}

export default AddChecklist;
